import { useState } from 'react';
import { DEFAULT_RULE_FILE, Validators } from '../conts';
import {
  FileStructureValidator,
  SavedWordsValidator,
  AutomationNamesValidator
} from '@linearb/gitstream-core-js';

const useRulesFileValidator = (defaultRuleFile = DEFAULT_RULE_FILE) => {
  const [ruleFile, setRuleFile] = useState(defaultRuleFile);
  const [errors, setErrors] = useState(null);

  const activateValidator = (validators, ruleFile) => {
    let resultString = '';
    if (!ruleFile) {
      return resultString;
    }
    Object.keys(validators).forEach(validator => {
      try {
        validators[validator].validate({ yamlFile: ruleFile });
      } catch (e) {
        resultString += `${e.message}\n`;
      }
    });
    return resultString;
  };

  const setRuleFileWithValidation = ruleFile => {
    setErrors('');
    setRuleFile(ruleFile);
    const errorValidators = {
      [Validators.FileStructureValidator]: new FileStructureValidator(),
      [Validators.SavedWordsValidator]: new SavedWordsValidator(),
      [Validators.AutomationNamesValidator]: new AutomationNamesValidator()
    };
    const errorsString = activateValidator(errorValidators, ruleFile);

    setErrors(errorsString);
  };

  return { ruleFile, errors, setRuleFile: setRuleFileWithValidation };
};

export default useRulesFileValidator;
